import axiosStatic from '../axiosStatic';

export const getStateData = () => axiosStatic.get('/static/data/weights/state.json');

export const getDistrictData = () => axiosStatic.get('/static/data/weights/district.json');

export const getSubdistrictData = () => axiosStatic.get('/static/data/weights/subdistrict.json');

export const getBlockData = () => axiosStatic.get('/static/data/weights/block.json');
